module.exports = __webpack_public_path__ + "img/53.c1086667.png";